import CalendarPreferences from '@/pages/CalendarPreferences.vue'
import CalendarSettings from '@/pages/CalendarSettings.vue'
import Connections from '@/pages/Connections.vue'
import Schedules from '@/pages/Schedules.vue'

import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/v2/location/:locationId/settings/calendars',
    name: 'calendar-settings__default',
    component: CalendarSettings,
  },
  {
    path: '/v2/location/:locationId/settings/calendars/preferences',
    name: 'calendar-settings__preferences',
    component: CalendarPreferences,
  },
  {
    path: '/v2/location/:locationId/settings/calendars/availability',
    name: 'calendar-settings__availability',
    component: Schedules,
  },
  {
    path: '/v2/location/:locationId/settings/calendars/connections',
    name: 'calendar-settings__connections',
    component: Connections,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
